<template>
  <div class="orderInfo">
    <el-table :data="rightRequestData" border stripe v-loading="isLoading">
      <el-table-column align="center" type="index"></el-table-column>
      <el-table-column
        align="center"
        prop="order_no"
        label="合同编号"
      ></el-table-column>
      <el-table-column
        prop="customer_name"
        label="客户名称"
        align="center "
      ></el-table-column>

      <el-table-column
        prop="promotion_title"
        label="项目名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="room_number"
        label="房间号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="subscribe_price"
        label="认购价"
        align="center"
      ></el-table-column>
	  <el-table-column
	    prop="staff_name"
	    label="经纪人"
	    align="center"
	  ></el-table-column>
      <el-table-column label="订单类型" align="center">
        <div slot-scope="scope">
          <div>
            {{ scope.row.order_type == 1 ? '认购' : '签约' }}
          </div>
        </div>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <div slot-scope="scope" class="operation">
          <div
            class="view"
            @click="advertiseUpdate(scope.row.id, scope.row.order_type)"
          >
            详情
          </div>
        </div>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="tablePage">
      <el-pagination
        hide-on-single-page
        background
        :current-page.sync="search.page"
        :page-size="search.limit"
        :total="search.total"
        :page-sizes="[15, 20, 25]"
        layout="total, sizes, prev, pager, next"
      ></el-pagination>
    </div>
    <!-- 详情 -->
    <el-dialog
      title="订单详情"
      custom-class="listDialog"
      width="800px"
      :visible.sync="rightDialog"
      right="100px"
      append-to-body
    >
      <el-descriptions
        class="margin-top"
        :title="order_type"
        :column="3"
        border
      >
       <el-descriptions-item>
         <template slot="label">订单编号</template>
         {{ rtRequestData.order_no }}
       </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">项目名称</template>
         {{ rtRequestData.promotion_title }}
       </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">房号</template>
         {{ rtRequestData.room_number }}
       </el-descriptions-item>
         <el-descriptions-item>
           <template slot="label">客户名称</template>
           {{ rtRequestData.customer_name }}
         </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">签约人</template>
         {{ rtRequestData.subscribe_name }}
       </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">签约人电话</template>
         {{ rtRequestData.subscribe_phone }}
       </el-descriptions-item>
       
       <el-descriptions-item>
         <template slot="label">渠道商名称</template>
         {{ rtRequestData.channel_name }}
       </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">案场联系人</template>
         {{ rtRequestData.channel_person }}
       </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">案场联系人电话</template>
         {{ rtRequestData.channel_phone }}
       </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">渠道经理</template>
         {{ rtRequestData.scene_person }}
       </el-descriptions-item>
       <el-descriptions-item>
         <template slot="label">渠道经理电话</template>
         {{ rtRequestData.scene_phone }}
       </el-descriptions-item>
       
         <el-descriptions-item>
           <template slot="label">经纪人</template>
           {{ rtRequestData.staff_name }}
         </el-descriptions-item>
        
       <el-descriptions-item>
         <template slot="label">订单金额</template>
         {{ rtRequestData.subscribe_price }}
       </el-descriptions-item>
         <el-descriptions-item>
           <template slot="label">佣金</template>
           {{ rtRequestData.brokerage }}
         </el-descriptions-item>
       
       	<el-descriptions-item></el-descriptions-item>
         <el-descriptions-item>
           <template slot="label">{{
             type == 1 ? '认购时间' : '签约时间'
           }}</template>
           {{ rtRequestData.order_time }}
         </el-descriptions-item>
         <el-descriptions-item v-if="type == 1 ? true : false">
           <template slot="label">预计签约时间</template>
           {{ rtRequestData.expect_sign_time }}
         </el-descriptions-item>
        
         <el-descriptions-item>
           <template slot="label">提交时间</template>
           {{ rtRequestData.create_time }}
         </el-descriptions-item>
         <el-descriptions-item v-if="rtRequestData.remark">
           <template slot="label">备注</template>
           {{ rtRequestData.remark }}
         </el-descriptions-item>
       </el-descriptions>
       <!-- 凭证 -->
       <h3 style="margin:20px 0">凭证</h3>
       <div style="imglist">
         <el-image
           v-for="(item, index) in rtRequestData.voucher"
           :key="index"
           style="width: 80px; height: 80px;margin:0 10px 10px 0"
           :src="item"
       	title="查看大图"
       	fit="cover"
           :preview-src-list="rtRequestData.voucher"
         >
         </el-image>
       </div>

      <div v-if="rtRequestData.property_owner.length == 0 ? false : true">
        <h3 style="margin:20px 0">共有产权人</h3>
        <el-table
          :data="rtRequestData.property_owner"
          border
          stripe
          v-loading="isLoading1"
          :header-cell-style="{ background: 'rgb(250, 250, 250)' }"
        >
          <el-table-column
            prop="relaname"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="电话"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="relation"
            label="关系"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button
          type="primary"
          size="small"
          @click="submitForm('rightTabForm')"
          >确 定</el-button
        > -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      Type: Number,
      default: 0,
    },
    index: {
      Type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      search: {
        total: 0,
        page: 1,
        limit: 15,
      },
      rightRequestData: [],
      type: '',
      isLoading1: false,
      rightDialog: false,
      rtRequestData: { property_owner: [] },
      order_type: '',
    }
  },
  watch: {
    'search.page'() {
      this.getImgList()
    },
    'search.limit'() {
      this.getImgList()
    },
    index(val) {
      if (val == 3) this.getImgList()
    },
  },
  methods: {
    // 详情
    async advertiseUpdate(id, type) {
      this.type = type
      this.isLoading1 = true
      if (type == 1) this.order_type = '认购订单'
      else this.order_type = '签约订单'
      this.rightDialog = true
      let param = {
        id: id,
      }
      const res = await this.$api.orderInfo(param)
      this.rtRequestData = res
      this.isLoading1 = false
    },
    async getImgList() {
      this.isLoading = true
      let param = {
        ...this.search,
        customer_id: this.id,
      }
      const date = await this.$api.orderList(param)
      this.search.total = date.count
      this.rightRequestData = date.data
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss">
orderInfo {
  .el-dialog {
    margin-right: 100px !important;
  }
  .imglist {
    width: 50px;
    height: 50px;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
